exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#footer a {\n  color: white;\n  border-bottom: dashed 1px white; }\n\n#footer span.attributions {\n  font-size: 8px;\n  line-height: .0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Footer.sass
// module id = 677
// module chunks = 0